import { ReactNode } from "react";

import classNames from "../../../../utils/classNames";
import { Tone } from "../../../../utils/callQueue";

// Meaning hues for the live queue: green = within max / go, amber = attention, red = over max or
// blocked, slate = vehicle and lead facts, gray = chrome. Tint recipe: -50 fill, -200 border, -700/-800 text.
export const toneClasses: Record<Tone, string> = {
  green: "bg-green-50 border-green-200 text-green-800",
  amber: "bg-amber-50 border-amber-200 text-amber-800",
  red: "bg-red-50 border-red-200 text-red-700",
  slate: "bg-slate-50 border-slate-200 text-slate-700",
  gray: "bg-gray-100 border-gray-200 text-gray-700",
};

export default function Pill({ tone, children, className }: { tone: Tone; children: ReactNode; className?: string }) {
  return (
    <span className={classNames("inline-flex items-center rounded-full border px-2 py-px text-[11px] font-semibold", toneClasses[tone], className)}>
      {children}
    </span>
  );
}

export function SectionCard({ title, right, children, className }: { title: string; right?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={classNames("overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm", className)}>
      <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-2.5 sm:px-5">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-600">{title}</h3>
        {right ? <div className="text-xs text-gray-600">{right}</div> : null}
      </div>
      {children}
    </section>
  );
}

export function Callout({ tone, icon, children }: { tone: "amber" | "red"; icon?: ReactNode; children: ReactNode }) {
  return (
    <div className={classNames("flex items-start gap-2 rounded-md border px-2.5 py-2 text-xs", toneClasses[tone])}>
      {icon ? <span className="mt-px flex-none">{icon}</span> : null}
      <div>{children}</div>
    </div>
  );
}
